import { render } from "./MyGivingLayout.vue?vue&type=template&id=7cc47f16&scoped=true"
import script from "./MyGivingLayout.vue?vue&type=script&lang=js"
export * from "./MyGivingLayout.vue?vue&type=script&lang=js"

import "./MyGivingLayout.vue?vue&type=style&index=0&id=7cc47f16&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cc47f16"]])

export default __exports__